import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function AuthGuard({ children, allowedRoles }) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-on-background">
        <span className="material-symbols-outlined animate-spin text-primary">progress_activity</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page and keep track of prior location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // KYC Gate: USER/client role only, never ADMIN or DEVELOPER
  if (user && user.role === 'USER' && !user.kycVerified && location.pathname !== '/kyc') {
    return <Navigate to="/kyc" replace />;
  }

  // Service Expiration Gate: USER/client role only, never ADMIN or DEVELOPER
  if (user && user.role === 'USER' && user.hasServiceBlock) {
    const isAllowedPath = [
      '/kyc',
      '/settings',
      '/tickets',
      '/tickets/new',
      '/service-expired',
      '/invoices',
      '/services'
    ].includes(location.pathname) || 
      location.pathname.startsWith('/tickets/') ||
      location.pathname.startsWith('/invoices/');

    if (!isAllowedPath) {
      return <Navigate to="/service-expired" replace />;
    }
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    // Redirect to access forbidden view if role doesn't match
    return <Navigate to="/403" replace />;
  }

  return children;
}
